import type { Role } from '@/types/role'
import { engineerCanAccessPath } from './engineerNav'

const ROLE_LEVEL: Record<Role, number> = {
  ultraadmin: 5,
  superadmin: 4,
  director: 3.5,
  admin: 3,
  hr: 2,
  teacher: 1,
  engineer: 0.5,
  partner: 0,
}

const SCHOOL_SCOPED_ROLES: Role[] = ['teacher', 'hr', 'director', 'admin']

const PATH_PREFIX_ROLES: Array<[string, Role]> = [
  ['/ultraadmin', 'ultraadmin'],
  ['/superadmin', 'superadmin'],
  ['/partner', 'partner'],
  ['/teacher', 'teacher'],
  ['/director', 'director'],
  ['/hr', 'hr'],
  ['/admin', 'admin'],
  ['/import', 'admin'],
]

export function minRoleForPath(pathname: string): Role | undefined {
  const path = pathname.split('?')[0] ?? pathname
  for (const [prefix, role] of PATH_PREFIX_ROLES) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return role
  }
  return undefined
}

export function roleMeetsMinRole(userRole: Role, minRole?: Role, pathname?: string, engineerScopes?: string[]): boolean {
  if (userRole === 'engineer') {
    if (!pathname) return !minRole
    return engineerCanAccessPath(pathname, engineerScopes ?? [])
  }
  if (userRole === 'partner') {
    if (minRole === 'partner') return true
    if (!minRole && pathname) {
      return pathname === '/dashboard' || pathname === '/help' || pathname.startsWith('/partner')
    }
    return false
  }
  if (minRole === 'partner') return false
  if (userRole === 'ultraadmin' && minRole && SCHOOL_SCOPED_ROLES.includes(minRole)) {
    return false
  }
  if (userRole === 'ultraadmin') {
    const path = (pathname ?? '').split('?')[0] ?? ''
    if (path === '/superadmin/dashboard' || path.startsWith('/superadmin/dashboard/')) {
      return false
    }
  }
  if (!minRole) return true
  if (SCHOOL_SCOPED_ROLES.includes(minRole)) {
    const path = (pathname ?? '').split('?')[0] ?? ''
    if (minRole === 'teacher' && (path === '/teacher/chats' || path.startsWith('/teacher/chats/'))) {
      return userRole === 'teacher' || userRole === 'director' || userRole === 'hr'
        || userRole === 'admin' || userRole === 'superadmin'
    }
    if (minRole === 'teacher' && path === '/timetable-export') {
      return userRole === 'teacher' || userRole === 'director' || userRole === 'hr'
        || userRole === 'admin' || userRole === 'superadmin'
    }
    if (minRole === 'admin' && userRole === 'superadmin') return true
    return userRole === minRole
  }
  return (ROLE_LEVEL[userRole] ?? 0) >= (ROLE_LEVEL[minRole] ?? 0)
}
